module.exports = __webpack_public_path__ + "img/chat.58e5f0a2.svg";